<template>
    <div class="background">
        <div>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Top/>
                </el-col>
            </el-row>
            <el-row class="row-main">
                <el-col :span="3" :offset="5" class="col-main">
                    <div class="div-main">
                        <Aside/>
                    </div>
                </el-col>
                <el-col :span="11" class="col-main">
                    <div class="div-main">
                        <h3>商品列表</h3>
                        <el-row :gutter="20" class="productRow">
                            <el-col class="productItem" v-for="(item,index) in list" :key="index">
                                <div @click="showDrawer(index)">
                                    <div>
                                        <img :src="item.img_url_hd">
                                    </div>
                                    <hr>
                                    {{item.product_name}}<br>
                                </div>
                            </el-col>
                        </el-row>
                        <el-drawer title="商品详情" size="66.7%" :visible.sync="drawer" >
                            <div class="drawer">
                                <div style="min-height:430px">
                                    <div style="float:left;width:400px">
                                        <img :src="img_url_hd" width="100%">
                                    </div>
                                    <div style="font-size:25px;">
                                        产品名称:{{product_name}}<br>
                                        产品规格:{{specifications}}
                                    </div>
                                </div>
                                <div style="float:block;">
                                    <div v-html="info">
                                    </div>
                                </div>
                            </div>
                        </el-drawer>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Footer/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import Top from './Top';
import Aside from './Aside';
import Footer from './Footer';
export default {
    name : 'ProductList',
    data() {
      return {
        list : [],
            drawer : false,
            product_name : "",
            img_url_hd :"",
            specifications : "",
            info : ""

      };
    },
    components: {
        'Top' : Top,
        'Aside' : Aside,
        'Footer' : Footer
    },
    mounted () {
        const _this = this;
        this.$axios
            .get('../static/json/productList.json?v=250904')
            .then(response => (
                this.list = response.data.productList,
                console.log(this.list)
            ));
    },
    methods: {
        showDrawer(index){
            this.drawer = true;
            this.product_name = this.list[index].product_name,
            this.img_url_hd = this.list[index].img_url_hd,
            console.log(this.img_url_hd),
            this.specifications = this.list[index].specifications,
            this.info = this.list[index].info
        }
    },
}
</script>
<style lang="scss" scoped>
/** 主组件DIV背景,高度铺满页面主DIV */
.background{
    height: 100%;
    // background: url('https://bing.biturl.top/?resolution=1920&format=image&index=0&mkt=zh-CN');
}
.background>div{
    background-color:  rgba(255, 255, 255, 0.5);
    height: 100%;
}
/deep/ .el-drawer__header span:focus {
    outline: 0;
}
/deep/ .el-drawer{
    overflow: scroll
}
.el-link{
    font-size: 20px;
}
.row-main{
    height: 80%;
    margin: 10px auto;
}
.col-main,.div-main{
    height: 100%;
}
.div-main{
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    background-color:  rgba(255, 255, 255, 0.9);
    border-radius: 4px;
}
.productRow{
    height: calc(100% - 25px);
    overflow-y:scroll;
    -ms-overflow-style: none;/*隐藏滚动条 IE10+ */
    overflow: -moz-scrollbars-none;/*隐藏滚动条 Firefox */
}
.productRow::-webkit-scrollbar{
    width: 0 !important;/*隐藏滚动条 Chrome sarfari */
}
.productItem{
    background-color:white;
    float:left;
    width:calc(24.5% - 10px);
    height:13vw;
    margin-left: 8px;
    margin-top: 8px;
}
.productItem img{
    width:100%;
}
.drawer{
    margin-left: 1.6%;
}
hr{
    color: aliceblue;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductList.vue